import api from './api';

export const dashboardService = {
  // Get dashboard overview stats
  getDashboardStats: async () => {
    const response = await api.get('/v1/dashboard/stats/');
    return response.data;
  },

  // Get chart data for sales trends
  getSalesChartData: async (period = '6m') => {
    const response = await api.get('/v1/dashboard/sales-chart/', { params: { period } });
    return response.data;
  },

  // Get lead sources data
  getLeadSourcesData: async () => {
    const response = await api.get('/v1/dashboard/lead-sources/');
    return response.data;
  },

  // Get inventory breakdown
  getInventoryBreakdown: async () => {
    const response = await api.get('/v1/dashboard/inventory-breakdown/');
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    const response = await api.get('/v1/dashboard/recent-activities/', { params: { limit } });
    return response.data;
  },

  // Get upcoming tasks
  getUpcomingTasks: async () => {
    const response = await api.get('/v1/dashboard/upcoming-tasks/');
    return response.data;
  },

  // Get performance metrics
  getPerformanceMetrics: async (period = 'month') => {
    const response = await api.get('/v1/dashboard/performance/', { params: { period } });
    return response.data;
  },
};